/**
 * Is this mouse event the user grabbing a SCROLLBAR?
 *
 * Every "close when the user clicks away" handler has to ask, because a
 * classic scrollbar is not a click away: it lives inside the element's border
 * box but outside its CLIENT box, and the mousedown that starts the drag is
 * dispatched to the scrolling element itself. So a plain "is the target inside
 * my menu" test reads a scrollbar grab as the user leaving, and the menu dies
 * the moment the bar is touched — reported across phr and bridge's new screens
 * (Nittin, 2026-09-24), where it killed dropdowns on release.
 *
 * It only ever bit some machines: macOS overlay scrollbars dispatch no mouse
 * event at all, so the bug is invisible unless "Show scroll bars: Always" is
 * set, or the reviewer is on Windows.
 *
 * Kept in one place rather than copied into each handler — usePopover and the
 * health plan's own picker both ask, and a second copy of a geometry test is
 * how two dropdowns end up disagreeing about what a click is.
 */
const isScrollbarPress = (e) => {
  if (!e || typeof e.clientX !== "number") return false;

  /* The page's own bars: past the document's client box. */
  const root = document.documentElement;
  if (root && (e.clientX > root.clientWidth || e.clientY > root.clientHeight)) return true;

  /* An inner scroller's bars: past the target's client box, but still within
     its border box — which is exactly the gutter the bar is drawn in. */
  const el = e.target;
  if (!el || typeof el.getBoundingClientRect !== "function") return false;
  const r = el.getBoundingClientRect();
  return (
    e.clientX > r.left + el.clientLeft + el.clientWidth ||
    e.clientY > r.top + el.clientTop + el.clientHeight
  );
};

export default isScrollbarPress;
